import DeepTagging from './DeepTagging'

export default DeepTagging
